<template>
	<div class='layerWrap' style='display:block;'>
		<div class='layerRow'>
			<div class='layerCell'>
				<div class='layerIn'>
					<img class='img' src='@/assets/img/ic_error_60.png'/>
					<!-- Title -->
					<div
						v-if='message.title'
						class='layerHd'>
						<h1 class='hTit'>주문안내</h1>
					</div>
					<!-- Content -->
					<div class='layerCnt'>
						<div class='lyIn'>
							{{$t(`${message.msg[0] ? message.msg[0]: ''}`)}}<br v-if='checkStringData($t(`${message.msg[0]}`))'/>
							<p v-if="message.msg[1]">{{$t(`${message.msg[1] ? message.msg[1]: ''}`)}}</p>
							<strong>{{$t(`${message.msg[2]? message.msg[2]: ''}`)}}</strong>
							<p>{{$t(`${message.msg[3]? message.msg[3]: ''}`)}}</p>
						</div>
					</div>
					<!-- 확인 버튼 -->
					<div class='layerBtm'>
						<ul>
							<li>
								<button
									@click.stop.prevent='adultOnClickConfirmBtn'
									type='button'
									class='btn'>
									확인
								</button>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="js">
import { SINGLE_BUTTON_DIALOG } from '@/utils/EndPoint'
import { MESSAGE_SINGLE_BUTTON } from '@/utils/Message'
import Vue from 'vue'
export default Vue.extend({
  name: SINGLE_BUTTON_DIALOG,
  props: [
    'messageType' // message type 번호
  ],
  data () {
    return {
      message: MESSAGE_SINGLE_BUTTON[this.messageType]
    }
  },
  mounted () { this.addDimForDialog() },
  destroyed () { this.removeDimForDialog() },
  methods: {
    adultOnClickConfirmBtn () {
      this.$emit('adultOnClickConfirmBtn')
    }
  }
})
</script>
